import { render, staticRenderFns } from "./GiacenzeDetails.vue?vue&type=template&id=05f63dec&scoped=true"
import script from "./GiacenzeDetails.vue?vue&type=script&lang=js"
export * from "./GiacenzeDetails.vue?vue&type=script&lang=js"
import style0 from "./GiacenzeDetails.vue?vue&type=style&index=0&id=05f63dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f63dec",
  null
  
)

export default component.exports